<template>
  <!-- 品牌实力 -->
  <div
    class="self-brand"
    :style="{
      backgroundImage: 'url(' + dataInfo.cover + ')'
    }"
  >
    <div class="g-box">
      <div class="self-con">
        <div class="le">
          <div class="en">{{ dataInfo.tips }}</div>
          <div class="zh">{{ dataInfo.name }}</div>
        </div>
        <div class="ri">
          <div class="con">
            <div class="swiper-container" id="swiper5" style="height:620px">
              <div class="swiper-wrapper">
                <div
                  class="item swiper-slide"
                  :style="{
                    backgroundImage: 'url(' + item.image + ')'
                  }"
                  v-for="item in dataList"
                  :key="item.id"
                >
                  <div class="tit">{{ item.title }}</div>
                  <div class="subtit">{{ item.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import Swiper from "swiper/swiper-bundle";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 999,
      menuId: this.menuId
    });
    this.dataInfo = dataInfo;
    this.dataList = data;
    this.$nextTick(() => {
      this.UserSwiper();
    });
    console.log(data, "dafddf1ta");
  },
  methods: {
    UserSwiper() {
      new Swiper("#swiper5", {
        loop: true,
        direction: "vertical",
        autoplay: true
      });
    }
  }
};
</script>
<style lang="less">
// 品牌实力
.self-brand {
  padding-top: 150px;
  display: flex;
  height: 1080px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  .self-con {
    display: flex;
    .le {
      margin-right: 119px;
      .en {
        font-size: 72px;
        font-family: "en-tit";
        color: #fff;
        line-height: 87px;
        text-transform: uppercase;
      }
      .zh {
        font-size: 48px;
        font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
        font-weight: 800;
        color: #fff;
        line-height: 70px;
      }
    }
    .ri {
      .con {
        height: 620px;
        width: 770px;
        .item {
          padding-left: 132px;
          padding-top: 126px;
          width: 770px;
          height: 620px;
          border-radius: 24px;
          box-sizing: border-box;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          .tit {
            height: 67px;
            font-size: 48px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fff;
          }
          .subtit {
            padding-top: 12px;
            text-transform: uppercase;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
